import React from 'react';
import { inject, observer } from 'mobx-react';
import { Trail, Spring, animated, config } from 'react-spring';

import Container from './Container';
import Header from './Header';
import NoOrders from './NoOrders';
import Body from './Body';
import Order from './Order';
import { startAnimation, endAnimation } from 'js/config/style';

export default inject('page')(
  observer(({ page }) => {
    const orders = page.orders;

    return (
      <Spring native from={startAnimation} to={endAnimation} config={config.gentle}>
        {animation => (
          <animated.div style={animation}>
            <Container>
              <Header>ORDERS IN PROGRESS</Header>
              {orders.length ? (
                <Body>
                  <Trail native items={orders} from={{ opacity: 0 }} to={{ opacity: 1 }} keys={order => order.uid}>
                    {order => animation => (
                      <animated.div style={animation}>
                        <Order order={order} />
                      </animated.div>
                    )}
                  </Trail>
                </Body>
              ) : (
                <NoOrders />
              )}
            </Container>
          </animated.div>
        )}
      </Spring>
    );
  }),
);
